export const ESPACIO_CASA_URL_KEY = 'espacio-de-la-casa'

export const getEspaciosCasaCategoriesQuery = /* GraphQL */ `
    query getEspaciosCasaCategories($urlKey: String!) {
        categories(filters: { url_key: { eq: $urlKey } }) {
            items {
                name
                url_path
                children {
                    name
                    url_key
                    url_path
                    position
                    include_in_menu
                    image
                    menu_icon
                    megamenu_image
                    megamenu_icon
                    megamenu_type
                    external_url
                }
            }
        }
    }
`
